module.exports = __webpack_public_path__ + "0bb57a18fc214b2b33f19b8211be39db.pdf";